import { useSyncExternalStore } from 'react';

/** Nothing ever changes: the answer only depends on which snapshot React asks for. */
const subscribe = (): (() => void) => () => {};
const onClient = (): boolean => true;
const onServer = (): boolean => false;

/**
 * False on the server and during hydration, true in every other render (web
 * plan W4.2).
 *
 * React reads the server snapshot while it renders HTML and while it hydrates
 * that HTML, then renders again with the client snapshot, so markup that only
 * makes sense in a browser (a map, "5m ago") never makes the hydrated tree
 * differ from the server's. A tree mounted with `createRoot` (the SPA today,
 * and every in-app navigation) gets `true` from its first render: no extra
 * render, no placeholder frame.
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(subscribe, onClient, onServer);
}

export default useIsClient;
